module.exports = __webpack_public_path__ + "img/info-grey.e199d3aa.svg";